import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { A11yButton } from '@fe-learner-common';
import * as Form from '@radix-ui/react-form';

const EMAIL_REGEX = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
export type FormValues = {
  email: string;
};
type CreateAccountFormProps = {
  onSubmit: (_: FormValues) => void;
  isLoading: boolean;
};

export const CreateAccountForm: FC<CreateAccountFormProps> = ({
  onSubmit,
  isLoading,
}) => {
  const intl = useIntl();
  const { register, handleSubmit, formState } = useForm<FormValues>({
    mode: 'onChange',
  });

  return (
    <Form.Root onSubmit={handleSubmit(onSubmit)}>
      <Form.Field className="mb-2.5 grid" name="email">
        <div className="space-y-2">
          <div className="flex items-baseline justify-between">
            <Form.Label className="ps-1 text-label-md ">
              {intl.formatMessage({ id: 'learner.common.email' })}
            </Form.Label>
            <Form.Message className="text-label-sm" match="valueMissing">
              {intl.formatMessage({
                id: 'learner.common.email.validation.empty',
              })}
            </Form.Message>
            <Form.Message className="text-label-sm" match="typeMismatch">
              {intl.formatMessage({
                id: 'learner.common.email.validation.type',
              })}
            </Form.Message>
          </div>
          <Form.Control asChild>
            <input
              id="email"
              type="email"
              className="l-input l-input-md"
              placeholder="Email"
              {...register('email', {
                required: true,
                pattern: {
                  value: EMAIL_REGEX,
                  message: intl.formatMessage({
                    id: 'learner.common.email.validation.type',
                  }),
                },
              })}
            />
          </Form.Control>
        </div>
      </Form.Field>
      <div className="flex flex-wrap justify-end gap-2 border-t-2 border-neutral-100 pt-4 ">
        <Form.Submit asChild>
          <A11yButton
            type="submit"
            isLoading={isLoading}
            disabled={!formState.isValid}
            className="l-btn l-btn-md l-btn-primary"
          >
            {intl.formatMessage({
              id: 'catalog.selfreg.account.create.title',
            })}
          </A11yButton>
        </Form.Submit>
      </div>
    </Form.Root>
  );
};
